<template>
  <div class="pin-input-container" :class="{ focused: isFocused }">
    <input
      v-for="(_, index) in pin"
      :key="index"
      type="text"
      class="pin-input"
      maxlength="1"
      v-model="pin[index]"
      @input="onInput(index)"
      placeholder="＿"
      @keydown.backspace="onBackspace(index)"
      @focus="isFocused = true"
      @blur="checkFocus"
      ref="inputRefs"
      inputmode="numeric"
      :data-qa="`code-input-field-${index + 1}-fill`"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue';

const emit = defineEmits(["pinCode"]);

const pin = reactive(["", "", "", ""]);
const inputRefs = ref<HTMLInputElement[]>([]);
const isFocused = ref(false);

const onInput = (index: number) => {
  // Разрешаем только цифры
  pin[index] = pin[index].replace(/\D/g, "");

  if (pin[index].length > 0 && index < 3) {
    inputRefs.value[index + 1].focus();
  }
  emit("pinCode", pin.join("").length >= 1 ? pin.join("") : null);
};

// Очистка полей через Backspace
const onBackspace = (index: number) => {
  if (pin[index] === "" && index > 0) {
    inputRefs.value[index - 1]?.focus();
  } else {
    pin[index] = ""; // Очищаем поле даже если оно уже заполнено
  }
};

// Проверка, остался ли хоть один input в фокусе
const checkFocus = () => {
  isFocused.value = inputRefs.value.some((input: HTMLInputElement) => input === document.activeElement);
};

// Установка фокуса на первый input в компоненте
const focusFirstInput = () => inputRefs.value[0]?.focus();

onMounted(() => {
  focusFirstInput();
})

// Отдаём метод для фокуса родительскому компоненту
defineExpose({ focusFirstInput });
</script>

<style scoped lang="scss">
.pin-input-container {
  display: flex;
  gap: 8px;
  justify-content: center;
  border: 1px solid #CCCCCC;
  border-radius: 3px;
  box-shadow: 1px 1px 5px 0 #00000014;
  transition: all 0.3s cubic-bezier(0, 0, 0.2, 1);

  &:hover {
    border-color: #30A8FF;
  }

  &.focused {
    border-color: #30A8FF;
    box-shadow: 0 0 0 2px #CBE9FF;
  }
}

.pin-input {
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 58px;
  text-align: center;
  outline: none;
  border: unset;
  box-shadow: unset;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #333333;

  &::placeholder {
    color: #CCCCCC;
  }
}

.pin-input:focus::placeholder {
  opacity: 0;
}
</style>